import m from "../../geodata/es2015/venezuelaLow";
window.am4geodata_venezuelaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/venezuelaLow.js
// module id = null
// module chunks = 